module.exports = __webpack_public_path__ + "static/img/head8.245b7dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head8.png
// module id = lvK1
// module chunks = 1